module.exports = __webpack_public_path__ + "img/4.fae77600.png";